let description1 = ["Revolutionize your business space with our top-tier low voltage solutions in San Diego. Elevate efficiency, security, and connectivity for a seamless commercial experience."];
let description2 = ["San Diego's Premier Commercial Low Voltage Partner","Empower your business with our specialized low voltage services. From robust network solutions to advanced security systems, we're your go-to partner for commercial success in San Diego."];
let description3 = ["Driving Innovation in San Diego","Fuel your commercial enterprise with our advanced low voltage technologies. Enhance productivity and security with tailored solutions designed for the dynamic business environment in San Diego."];

module.exports = {
    description1,
    description2,
    description3
  };